import { z } from 'zod';
import { localeModeSchema, localeSchema } from './locale-schemas.js';
const challengeSolutionSchema = z
    .object({
    nonce: z.string().min(8).max(128),
    difficulty: z.number().int().min(1).max(8),
    expiresAt: z.string().min(10).max(40),
    signature: z.string().min(16).max(128),
    solution: z.string().min(1).max(32),
})
    .strict();
export const widgetBootstrapRequestSchema = z
    .object({
    publicSiteId: z.string().regex(/^pub_[0-9a-f]{32}$/),
    challenge: challengeSolutionSchema.optional(),
})
    .strict();
export const widgetSessionRequestSchema = z
    .object({
    ticket: z.string().trim().min(20).max(300),
    challenge: challengeSolutionSchema.optional(),
})
    .strict();
export const widgetConversationRequestSchema = z
    .object({
    locale: localeSchema.optional(),
})
    .strict();
export const widgetMessageRequestSchema = z
    .object({
    requestId: z.uuid(),
    text: z.string().trim().min(1).max(2_000),
    localeMode: localeModeSchema,
    selectedLocale: localeSchema.nullable(),
})
    .strict();
export const widgetFeedbackRequestSchema = z
    .object({
    messageId: z.uuid(),
    rating: z.enum(['HELPFUL', 'NOT_HELPFUL']),
})
    .strict();
export const widgetLeadRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(200),
    email: z.email().max(320),
    phone: z.string().trim().max(40).optional(),
    message: z.string().trim().min(1).max(4_000),
    marketingOptIn: z.boolean().default(false),
    noticeAccepted: z.literal(true),
})
    .strict();
export const widgetAnswerStatuses = ['REFUSED', 'FAILED'];
//# sourceMappingURL=widget.js.map